import type { ChatFrame } from '../../store/types';

const ROLE_LABEL: Record<ChatFrame['messages'][number]['role'], string> = {
  user: 'You',
  assistant: 'Agent',
  system: 'System',
};

/** Render a chat frame's messages as a Markdown transcript. */
export function chatTranscriptMarkdown(frame: ChatFrame): string {
  const scope = frame.anchorId ? `scoped to \`${frame.anchorId}\`` : 'global scope';
  const lines: string[] = [`# Chat transcript — ${scope}`, ''];
  for (const m of frame.messages) {
    const label = ROLE_LABEL[m.role];
    if (m.role === 'system') {
      // System/step notes as a blockquote so they read as meta.
      lines.push(...m.text.split('\n').map((l) => `> ${l}`), '');
    } else {
      lines.push(`**${label}:**`, '', m.text, '');
    }
  }
  return lines.join('\n').trimEnd() + '\n';
}

/** Safe-ish filename for a chat transcript download. */
export function chatTranscriptFilename(frame: ChatFrame): string {
  const base = (frame.title || frame.id).replace(/[^a-z0-9._-]+/gi, '-').replace(/^-+|-+$/g, '');
  return `${base || 'chat'}.md`;
}
